// Bahama mobile drawer enhancement: prepend a HOME link if the menu doesn't already have one.
(function () {
  function ensureHome() {
    var ul = document.querySelector('.menu-drawer__menu, ul.menu-drawer__menu');
    if (!ul || ul.dataset.bpHome === '1') return;
    // Skip if a Home link is already in the menu (matches by href '/' or text 'Home').
    var already = Array.prototype.some.call(ul.querySelectorAll('a'), function (a) {
      var href = (a.getAttribute('href') || '').trim();
      var txt = (a.textContent || '').trim().toLowerCase();
      return href === '/' || href === window.location.origin + '/' || txt === 'home';
    });
    if (already) { ul.dataset.bpHome = '1'; return; }

    var firstLi = ul.querySelector('li');
    if (!firstLi) return;
    var li = document.createElement('li');
    li.className = firstLi.className;
    li.style.cssText = '--menu-drawer-animation-index: 0;';
    var a = document.createElement('a');
    a.href = '/';
    a.id = 'HeaderDrawer-home';
    a.className = 'menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset';
    var span = document.createElement('span');
    span.className = 'menu-drawer__menu-item-text';
    span.textContent = 'HOME';
    a.appendChild(span);
    li.appendChild(a);
    ul.insertBefore(li, firstLi);
    ul.dataset.bpHome = '1';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureHome);
  } else {
    ensureHome();
  }
  // Re-run when the drawer is opened (in case Savor lazy-renders content)
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && (t.closest('.menu-drawer-container') || t.closest('summary'))) {
      setTimeout(ensureHome, 50);
    }
  }, true);
})();

// Article product tiles + bundle tiles, make the whole tile clickable to the
// correct product page. The external ScriptTag renders these as <div> tiles
// with a <span class="bahama-cta-btn"> "Shop Now" button (not real links), so
// we wrap each tile in an anchor at runtime by matching the tile's product name
// to one of the three Bahama product handles.
(function () {
  var HANDLES = [
    { match: /(mega|foaming\s*soap|graphene\s*wash)/i, url: '/products/ceramic-mega-foaming-soap' },
    { match: /(interior\s*cleaner|interior)/i, url: '/products/ceramic-interior-cleaner' },
    { match: /(simple\s*finish|detail\s*spray|finish)/i, url: '/products/ceramic-simple-finish' }
  ];
  function resolveUrl(name) {
    var s = (name || '').toString();
    for (var i = 0; i < HANDLES.length; i++) {
      if (HANDLES[i].match.test(s)) return HANDLES[i].url;
    }
    return null;
  }
  function wireTile(tile) {
    if (tile.dataset.bpTile === '1') return;
    var nameEl = tile.querySelector('.bahama-product-tile-name, .bahama-bundle-name');
    var imgEl = tile.querySelector('.bahama-product-tile-img, .bahama-bundle-tile-img');
    var url = resolveUrl(nameEl ? nameEl.textContent : '') || resolveUrl(imgEl ? imgEl.alt : '');
    if (!url) return;
    tile.dataset.bpTile = '1';
    tile.style.cursor = 'pointer';
    tile.setAttribute('role', 'link');
    tile.setAttribute('tabindex', '0');
    function go() { window.location.href = url; }
    tile.addEventListener('click', function (e) {
      // ignore clicks on real anchors that already navigate
      if (e.target.closest('a[href]')) return;
      e.preventDefault();
      go();
    });
    tile.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); }
    });
    // Upgrade the inner CTA span to behave like a link button
    tile.querySelectorAll('.bahama-cta-btn, .bahama-bundle-cta').forEach(function (btn) {
      btn.style.cursor = 'pointer';
    });
  }
  function init(root) {
    (root || document).querySelectorAll('.bahama-product-tile, .bahama-bundle-tile').forEach(wireTile);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();

// Lazy YouTube/Vimeo embed, swaps thumbnail for iframe on click. Vanilla JS, no deps.
(function () {
  function init(root) {
    root.querySelectorAll('.bp-video--lazy').forEach(function (el) {
      if (el.dataset.bpInit === '1') return;
      el.dataset.bpInit = '1';
      var btn = el.querySelector('.bp-video__play');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var iframe = document.createElement('iframe');
        iframe.className = 'bp-video__frame';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen');
        iframe.setAttribute('title', el.dataset.bpTitle || 'Video');
        var yt = el.dataset.bpYt;
        var vimeo = el.dataset.bpVimeo;
        if (yt) {
          iframe.src = 'https://www.youtube-nocookie.com/embed/' + yt + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
        } else if (vimeo) {
          iframe.src = 'https://player.vimeo.com/video/' + vimeo + '?autoplay=1&dnt=1';
        } else {
          return;
        }
        el.appendChild(iframe);
        el.classList.add('bp-video--playing');
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
